import {parseDate} from './date';
import {WEB_HOST} from '../constant';

export function getCookie(key: string): string {
  const name = key + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.startsWith(name)) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie({
  key,
  value,
  expire = A_MONTH_BY_HOURS,
}: {
  key: string;
  value: string | number;
  expire?: number | Date;
}) {
  let expires = 'expires=Session';
  if (expire) {
    if (typeof expire === 'number') {
      const d = new Date();
      d.setTime(d.getTime() + expire * 60 * 60 * 1000);
      expires = 'expires=' + d.toUTCString();
    } else {
      expires = 'expires=' + expire.toUTCString();
    }
  }
  const domain = WEB_HOST.replace(/https:\/\/.*(\.\w*\.\w*)(:8081)?/, '$1');
  document.cookie = `${key}=${value}; Path=/; ${expires}; Domain=${domain}; secure;`;
}
const A_MONTH_BY_HOURS = 24 * 30;

export function deleteCookie(key: string) {
  setCookie({key, value: '', expire: parseDate('1970-01-01')});
}
